function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "38.7,443.1 -92.9,443.1 -103,433 28.6,433  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "59,463.3 -72.6,463.3 -82.8,453.2 48.8,453.2  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "79.2,483.6 -52.4,483.6 -62.5,473.4 69.1,473.4  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "99.5,503.8 -32.1,503.8 -42.3,493.7 89.7,493.7  "
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "119.7,524.1 119.7,524.1 -12.3,524.1 -22,513.9 109.6,513.9  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "140,544.3 8.4,544.3 -1.8,534.2 129.8,534.2  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "180.5,584.8 48.8,584.8 38.7,574.7 170.4,574.7  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "160.2,564.6 28.6,564.6 18.5,554.4 150.1,554.4  "
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "-22,574.7 -22,584.8 -103,584.8 -103,433 -92.9,443.1 -92.9,574.7  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "-22,554.4 -22,564.6 -82.8,564.6 -82.8,453.2 -72.6,463.3 -72.6,554.4  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "-22,534.2 -22,544.3 -62.5,544.3 -62.5,473.5 -62.5,473.5 -52.4,483.6 -52.4,534.2  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "-22,513.9 -22,524.1 -42.3,524.1 -42.3,493.7 -32.1,503.8 -32.1,513.9  "
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "119.7,493.7 119.7,524.1 109.6,514 109.6,503.8 99.5,503.8 99.5,493.7  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "140,473.5 140,544.3 129.8,534.2 129.8,483.6 99.5,483.6 99.5,473.5  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "180.5,433 180.5,584.8 170.4,574.7 170.4,443.1 99.5,443.1 99.5,433  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "160.2,453.2 160.2,564.6 150.1,554.4 150.1,463.3 99.5,463.3 99.5,453.2  "
})))))), React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M246.7,473.5h-8.6l-17-23.7v23.7h-10.2v-40.6h9.9l15.6,22.3v-22.3h10.2v40.6H246.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M269,473.5V472c-1,1-4,2-7.1,2c-5.9,0-10.8-3.3-10.8-9.6c0-5.7,4.9-9.4,11.4-9.4c2.4,0,5.3,0.8,6.5,1.6v-1.9 c0-1.9-1.1-3.6-3.6-3.6c-1.9,0-3,0.9-3.5,2.2h-9.8c0.9-5.7,5.9-10.3,13.6-10.3c8.4,0,13.3,4.5,13.3,12.2v18.2L269,473.5L269,473.5 z M269,463.4c-0.7-1.3-2.4-2-4.4-2s-4.1,0.9-4.1,2.8c0,2,2,2.9,4.1,2.9c1.9,0,3.7-0.8,4.4-2V463.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,451.8h-4.4v-8.1h4.4v-8.1h10.2v8.2h6.2v8.1h-6.2v9.9c0,2.3,1.1,3.3,3.2,3.3c1.1,0,2.4-0.3,3.3-0.7v8.7 c-1.2,0.5-3.4,0.9-5.7,0.9c-7,0-11-3.3-11-10.8V451.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M312.7,441.3c-3.2,0-5.9-2.2-5.9-5.5c0-3.4,2.7-5.6,5.9-5.6s5.9,2.2,5.9,5.6 C318.6,439.1,315.9,441.3,312.7,441.3z M317.9,473.5h-10.4v-29.7h10.4V473.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M337.1,474.1c-9,0-15.2-6.3-15.2-15.5s6.2-15.5,15.2-15.5s15.2,6.3,15.2,15.5S346.1,474.1,337.1,474.1z  M337.1,451.6c-3.2,0-4.9,2.9-4.9,7s1.8,6.9,4.9,6.9c3.2,0,5-2.8,5-6.9S340.3,451.6,337.1,451.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M356.3,443.8h10.4v2.6c1.6-1.8,4.6-3.2,8-3.2c6.6,0,10.5,4.3,10.5,10.9v19.5h-10.3v-17c0-2.4-1.3-4.2-3.9-4.2 c-2,0-3.8,1.2-4.3,3.2v18h-10.4L356.3,443.8L356.3,443.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M407,473.5V472c-1,1-4,2-7.1,2c-5.9,0-10.8-3.3-10.8-9.6c0-5.7,4.9-9.4,11.4-9.4c2.4,0,5.3,0.8,6.5,1.6v-1.9 c0-1.9-1.1-3.6-3.6-3.6c-1.9,0-3,0.9-3.5,2.2h-9.8c0.9-5.7,5.9-10.3,13.6-10.3c8.4,0,13.3,4.5,13.3,12.2v18.2L407,473.5L407,473.5 z M407,463.4c-0.7-1.3-2.4-2-4.4-2s-4.1,0.9-4.1,2.8c0,2,2,2.9,4.1,2.9c1.9,0,3.7-0.8,4.4-2V463.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M432.4,473.5H422v-42.9h10.4V473.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M221.4,516.1v13.4h-10.5v-40.6h18.2c8.7,0,14.7,4.9,14.7,13.8c0,6.1-3.1,10.4-8.1,12.2l9.5,14.5h-11.7 l-8.4-13.3H221.4z M221.4,507.6h6.6c3.8,0,5.5-1.9,5.5-4.9s-1.7-4.9-5.5-4.9h-6.6V507.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M275.6,519.1c-1.1,6.9-6.2,11-13.9,11c-9.1,0-15.1-6.3-15.1-15.5c0-9.2,6.3-15.5,14.9-15.5 c9.1,0,14.3,6.1,14.3,14.9v2.6h-19.2c0.3,3.6,2.2,5.5,5.1,5.5c2.1,0,3.8-0.9,4.4-3H275.6z M256.8,511.4h9 c-0.1-2.4-1.6-4.3-4.2-4.3C259.1,507.2,257.4,508.7,256.8,511.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M288.3,520.3c0.5,1.6,1.9,2.6,3.8,2.6c1.7,0,3-0.7,3-2c0-1.1-0.9-1.5-2.3-1.8l-5.8-1.2 c-4.9-1.1-8.2-3.4-8.2-8.6c0-6.3,5.7-10,12.7-10c8.1,0,12.5,3.8,13.5,9.6h-9.6c-0.3-1.3-1.3-2.4-3.6-2.4c-1.5,0-2.8,0.7-2.8,2 c0,0.9,0.7,1.4,2,1.6l5.9,1.4c5.4,1.3,8.3,4.1,8.3,8.9c0,6.3-5.7,9.8-13,9.8c-7.6,0-13.1-3.4-14-9.8h10.1V520.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M336.9,519.1c-1.1,6.9-6.2,11-13.9,11c-9.1,0-15.1-6.3-15.1-15.5c0-9.2,6.3-15.5,14.9-15.5 c9.1,0,14.3,6.1,14.3,14.9v2.6h-19.2c0.3,3.6,2.2,5.5,5.1,5.5c2.1,0,3.8-0.9,4.4-3H336.9z M318.1,511.4h9 c-0.1-2.4-1.6-4.3-4.2-4.3C320.4,507.2,318.7,508.7,318.1,511.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M357.7,529.5V528c-1,1-4,2-7.1,2c-5.9,0-10.8-3.3-10.8-9.6c0-5.7,4.9-9.4,11.4-9.4c2.4,0,5.3,0.8,6.5,1.6 v-1.9c0-1.9-1.1-3.6-3.6-3.6c-1.9,0-3,0.9-3.5,2.2h-9.8c0.9-5.7,5.9-10.3,13.6-10.3c8.4,0,13.3,4.5,13.3,12.2v18.2L357.7,529.5 L357.7,529.5z M357.7,519.4c-0.7-1.3-2.4-2-4.4-2s-4.1,0.9-4.1,2.8c0,2,2,2.9,4.1,2.9c1.9,0,3.7-0.8,4.4-2V519.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M392.7,509.6c-1.3-0.7-2.6-0.9-4.3-0.9c-2.8,0-4.8,1.3-5.3,3.4v17.4h-10.4v-29.7h10.4v2.6 c1.5-2,3.8-3.3,6.7-3.3c1.3,0,2.4,0.3,2.8,0.5L392.7,509.6L392.7,509.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M409.9,499.1c8,0,12.9,4.8,13.8,11.7h-10c-0.3-1.8-1.7-3.1-3.8-3.1c-2.9,0-4.8,2.7-4.8,6.9 c0,4.2,1.8,6.9,4.8,6.9c2.1,0,3.5-1.3,3.8-3h10c-0.9,6.9-5.8,11.7-13.8,11.7c-8.9,0-15-6.3-15-15.5 C394.9,505.4,401,499.1,409.9,499.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M427.6,486.6H438v15.8c1.7-1.8,4.6-3.2,8-3.2c6.6,0,10.5,4.3,10.5,10.9v19.5h-10.3v-17c0-2.4-1.3-4.2-3.9-4.2 c-2,0-3.8,1.2-4.3,3.2v17.9h-10.4V486.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M230.7,571.7v-7.9h16.8v4c0,11.2-7.4,18.3-18.1,18.3c-11.7,0-20.1-8.6-20.1-20.9s8.3-20.9,19.9-20.9 c10.4,0,16.4,6,18,14.3h-10.8c-1.1-3.1-3.3-4.9-7.1-4.9c-5.9,0-9.2,4.9-9.2,11.6c0,6.9,3.6,11.6,9.4,11.6c4,0,6.7-2,7.7-5.1h-6.5 V571.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M271.7,565.6c-1.3-0.7-2.6-0.9-4.3-0.9c-2.8,0-4.8,1.3-5.3,3.4v17.4h-10.4v-29.7h10.4v2.6 c1.5-2,3.8-3.3,6.7-3.3c1.3,0,2.4,0.3,2.8,0.5L271.7,565.6L271.7,565.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M289,586.1c-9,0-15.2-6.3-15.2-15.5c0-9.2,6.3-15.5,15.2-15.5c9,0,15.2,6.3,15.2,15.5 C304.2,579.8,298.1,586.1,289,586.1z M289,563.6c-3.2,0-4.9,2.9-4.9,7c0,4.1,1.8,6.9,4.9,6.9c3.2,0,5-2.8,5-6.9 C294,566.5,292.3,563.6,289,563.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M336.8,585.5h-10.4v-2.6c-1.6,1.8-4.6,3.2-7.9,3.2c-6.5,0-10.4-4.3-10.4-10.9v-19.5h10.3v17 c0,2.5,1.2,4.3,3.8,4.3c1.9,0,3.7-1.3,4.2-3.3v-18h10.4V585.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M352.7,596h-10.4v-40.2h10.4v2.4c1.4-1.6,4.3-3,7.3-3c8.6,0,13.3,7,13.3,15.5c0,8.4-4.7,15.5-13.3,15.5 c-3,0-5.9-1.5-7.3-3V596z M352.7,574.5c0.8,1.6,2.6,2.8,4.6,2.8c3.6,0,5.7-2.8,5.7-6.7c0-3.8-2.1-6.7-5.7-6.7 c-2,0-3.8,1.2-4.6,2.8V574.5z"
})));

var SvgNrg = function SvgNrg(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-103 430.1 559.4 165.9",
    style: {
      enableBackground: "new -103 430.1 559.4 165.9"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/nrg.1ccc3028.svg";
export { SvgNrg as ReactComponent };